// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3173) return "static/chunks/3173.becbdda1376ec92a.js";
	if (chunkId === 2272) return "static/chunks/2272.797d2718384781c7.js";
	if (chunkId === 8407) return "static/chunks/8407.bcaa91716e2f8a52.js";
	if (chunkId === 8736) return "static/chunks/8736.89ec7fd79972c6a5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1106":"ba4413b8fa23a1e1","2936":"6a3ce68a7c57b1c9","8262":"eabfeefd0e7c82c0","9306":"5225554d2f862444","9965":"022a58a661cfd9e7"}[chunkId] + ".js";
};